import $ from 'jquery';

function initSelectionButton() {
  $('.selection_button').on('click', function(event) {
    var belong_group = "." + $(this).data('belong-group');
    $(belong_group).addClass("hidden");
    var target = "." + $(this).data('show');
    $(target).removeClass("hidden");
  });
  
  $('.selection_field').on('change', function(event) {
    var target = $(this).data('target');
    var target_from = $('[data-target="' + target + '"][data-condition="larger_than"]').val() || 0;
    var target_to = $('[data-target="' + target + '"][data-condition="smaller_than"]').val() || 100;
    var act_no = $('[data-target="' + target + '"][data-condition="act_no"]').val() || "";
    $("." + target).each(function() {
      if (($(this).data('to') < target_from) || ($(this).data('from') > target_to) || !($(this).data('act-no-group').includes(act_no))) {
        $(this).addClass("hidden");
      } else {
        $(this).removeClass("hidden");
      }
    });
  });
}

export default initSelectionButton;